import { AddCustomerNewComponent } from "../app/dashboard/add-customer-new/add-customer-new.component";

export const environment = {
    idString: '_id',
    production: false,
    nameDisplay: false,
    userRolesListName: "USER_ROLES_GENERIC",
    loginAsUserEnabled: true,
    paymentRequired: false,
    logsRequired: false,
    editOptionOcr: false,
    customerLogin: false,
    disableApplyfLoan: false,
    equifaxFileName: "equifax",
    height: "4rem",
    width: "11rem",
    sheight: "3rem",
    swidth: "5rem",
    addCustomerComponent: AddCustomerNewComponent,

    navList: {
        role_1: 'ADMIN',
        role_2: 'MANAGER',
        role_3: 'LEAD',
        role_4: 'LEAD',
        role_5: 'SALES',
        role_6: 'CREDIT',
        role_7: 'OPERATION',
        role_8: 'OPERATION',
        role_9: 'BC_USER',
        role_10: 'USER',
        role_default: 'NAVIGATION_WTSLN_DEFAULT'
    },


    privacy: "Privacy Policy and Terms of Use",

    INDIV_OR_NONINDIV: [
        { codeType: "", id: "1", type: "Individual" },
        { codeType: "", id: "2", type: "Non-Individual" },
    ],

    LOAN_CUSTOMER_TYPE: [
        { id: "1", type: "Salaried" },
        { id: "2", type: 'Self Employed - Professional' },
        { id: "3", type: 'Self Employed - Others' },
        { id: "4", type: "Farmer Agri" },
        { id: "5", type: "Farmer + Salaried" },
        { id: "6", type: "Farmer + Self Employed - Professional" },
        { id: "7", type: "Farmer + Self Employed - Others" },
        { id: "8", type: "Farmer Others" },
        { id: "9", type: "MSME Agri" },
        // { codeType: "301159", code: "2", type: "MSME Business" },
        // { codeType: "301159", code: "1", type: "Consumer Retail" },
    ],

    NONINDIVIDUAL_TYPE: [
        { codeType: "", id: "1", type: "Proprietary" },
        { codeType: "", id: "2", type: "Partnership" },
        //{ codeType: "", id: "5", type: "Trusts/Societys/Institutions/Club" },
        //{ codeType: "", id: "6", type: "AOPs" },
        //{ codeType: "", id: "7", type: "HUFs" },
        { codeType: "", id: "3", type: "LLP" },
        { codeType: "", id: "4", type: "FPO" },
        { codeType: "", id: "4", type: "Private Limited" },
        { codeType: "", id: "5", type: "Trust" },
        { codeType: "", id: "6", type: "Society" },
        { codeType: "", id: "7", type: "AOP" },

    ],


    loanTypes: [
        "Proprietary",
        "Partnership",
        "LLP",
        "FPO",
        "Private Limited",
        "Trust",
        "Society",
        "AOP",
        "Salaried",
        'Self Employed - Professional',
        'Self Employed - Others',
        //  "Farmer Agri" ,
        "Farmer + Salaried",
        "Farmer + Self Employed - Professional",
        "Farmer + Self Employed - Others",
        "Farmer Others",
        "MSME Agri",
        "Gold",
        "Retail",
        "Business",
        "Savings Account"
    ],

    type: "Profile Type",
    custType: 'Profile',
    panRequired: false,
    profileType: 'Profile Type',
    // nodeUrl:"http://localhost:8089",

    // nodeUrl: "http://192.168.1.18:8081",
    // nodeUrl:"https://633d-49-36-214-85.ngrok.io",
    nodeUrl: "https://sahyadrifarms-uat.whatsloan.com",
    encryptRequestUrl: "https://sahyadrifarms-uat.whatsloan.com/",
    projectName: 'sahyadarifarms',
    viewCustomerProjectName: 'sfarms',
    digiProject: 'sahyadrifarms',
    logo: '../../assets/sahyadarifarms.jpg',
    smallLogo: "../../assets/sahyadarifarms.jpg",
    key: 'rzp_test_fbWcQYzGIGylZr',

    digiProjectBusiness: '/dashboard/businessKyc/digilocker',
    digiProjectAgri: '/dashboard/AgriKcc/digilocker',


    digilocker: {
        username: 'shriraksh_app',
        apiKey: 'dHofezwquY8KCzJoiTsr',//need to change
        popupUrl: 'https://services.digitallocker.gov.in/index.php',
        docUrl: 'https://partners.digitallocker.gov.in/public/requestor/api/pulldoc/1/xml',

        redirect_Uri: 'https://sahyadrifarms-uat.whatsloan.com/dashboard/businessKyc/digilocker/fetch',
        clientId: 'EDD69BCD',
        clientSecret: '20fa7d8c71',
        link: 'https://s3.ap-south-1.amazonaws.com/wl-marketplaces/'

    },
    docUrl: 'https://sahyadrifarms-uat.whatsloan.com/',

    shareKey: "PLACEHOLDERKEY",
    congratsUrlSubDom: "kccnew",
    imageUrl: "https://s3.ap-south-1.amazonaws.com/wl-marketplaces/",
    imageUrlforms: "https://s3.ap-south-1.amazonaws.com/wl-marketplaces",
    disableInput: false,
    displayStatuses: "block",
    assistedUrl: "https://qa-bharatmandi.whatsloan.com/landing/assisted-journey",
    sseUrl: "https://sahyadrifarms-uat.whatsloan.com/v1/assist-mode/checkApplicantCompletionStatus?mobileNumber=",

    link: "https://sahyadrifarms-uat.whatsloan.com/landing",

    frontendUrl: "https://sahyadrifarms-uat.whatsloan.com/",

    urlSetting: {
        demo: 'http://localhost:4200/',
        url: 'https://sfl.sirsiurbanbank.whatsloan.com/',
        ydlUrl: 'http://localhost:4200/laas/financial/bank-statement/transaction',
        live: 'https://sfl.sirsiurbanbank.whatsloan.com/',
    },

    googleAddress: {
        // apiKey: 'AIzaSyD9L0R0hYEYomh7DLspxgqIXnC12nOp4JE',
        // AIzaSyAu8zMVYitAAnuG04eoxtMb4pJhvdBVAMM //confident projects api key
        apiKey: 'AIzaSyAWiHE0okg-Uro_IxRTgGAvpnP1BYe1uJA',//paid api key
        libraries: ['places'],
        googleUrl: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=',
        addressUrl: 'https://maps.googleapis.com/maps/api/geocode/json?address=',
        translateUrl: 'https://translation.googleapis.com/language/translate/v2?key='
    },




    salaried: [

        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
                // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                {
                    name: 'Credit Report',
                    link: '/dashboard/businessKyc/crif-report'
                },
                { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Proof',
            faIcon: 'account_balance_wallet',
            submenu: [
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                { name: 'Payslip', link: '/dashboard/businessKyc/payslip' },
                { name: 'Form 16', link: 'form16' },
                { name: 'Form 26As', link: 'form26as' },
                { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],


    Self_employed_professional: [
        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
                { name: 'Aadhar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                {
                    name: 'Credit Report',
                    link: '/dashboard/businessKyc/crif-report'
                },
                { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
                { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
                // { name: 'Unit Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'Udyam *', link: '/dashboard/businessKyc/udyam' },
                { name: 'Shops & Establishment', link: '/dashboard/businessKyc/shops' },
                { name: 'CRIF Commercial', link: '/dashboard/businessKyc/crifCommercial' },

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Proof',
            faIcon: 'account_balance_wallet',
            submenu: [
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                // { name: 'Payslip', link: '/dashboard/businessKyc/payslip'},
                { name: 'Form 16', link: 'form16' },
                { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
                { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
                // { name: 'Bank Statement - Online *', link: 'BankOnline' },
                // { name: 'Investment / Mutual Fund', link:''},



            ],
            isSubmenuVisible: false
        },

        {
            name: 'Professional ID',
            faIcon: 'folder_shared',
            submenu: [
                { name: 'ICAI', link: '/dashboard/businessKyc/icai' },
                { name: 'ICSI', link: '/dashboard/businessKyc/icsi' },
                { name: 'ICWAI Firm', link: '/dashboard/businessKyc/icwaif' },
                { name: 'ICWAI Membership', link: '/dashboard/businessKyc/icwaim' },
                { name: 'MCI Membership', link: '/dashboard/businessKyc/mci' },


            ],
            isSubmenuVisible: false
        },


        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
                // { name: 'Land Verification'},
                // { name: 'Property'}




            ],
            isSubmenuVisible: false
        },



        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],

    Self_employed_others: [
        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
                // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                {
                    name: 'Credit Report',
                    link: '/dashboard/businessKyc/crif-report'
                },
                { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
                { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
                // { name: 'Unit Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'Udyam *', link: '/dashboard/businessKyc/udyam' },
                { name: 'Shops & Establishment', link: '/dashboard/businessKyc/shops' },
                { name: 'CRIF Commercial', link: '/dashboard/businessKyc/crifCommercial' },

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Proof',
            faIcon: 'account_balance_wallet',
            submenu: [
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                // { name: 'Payslip', link: '/dashboard/businessKyc/payslip'},
                { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
                { name: 'Form 16', link: 'form16' },
                { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
                // { name: 'Bank Statement - Online *', link: 'BankOnline' },
                // { name: 'Investment / Mutual Fund', link:''},



            ],
            isSubmenuVisible: false
        },




        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
                // { name: 'Land Verification', },
                // { name: 'Property', }




            ],
            isSubmenuVisible: false
        },

        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],


    salaried_coApp: [

        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar', link: '/dashboard/businessKyc/aadhar' },
                // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                //   {
                //     name: 'Credit Report',
                //   link: '/dashboard/businessKyc/crif-report'
                // },
                { name: 'Passport', link: '/dashboard/businessKyc/Passport' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' },
                { name: 'Other Address Proof', link: '/dashboard/businessKyc/otheraddressproof' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Details',
            faIcon: 'account_balance_wallet',
            submenu: [
                // {name: 'Income Details', link: '/dashboard/businessKyc/income'},
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                { name: 'Payslip/Salary Certificate', link: '/dashboard/businessKyc/payslip' },
                { name: 'Form 16', link: 'form16' },
                // // { name: 'Form 26As', link:'form26as'},
                //  { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - Online FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
                { name: 'Rental Agreement', link: '/dashboard/businessKyc/rental-agreement', tooltip: 'Rental Agreement' },
                // { name: 'P & L', link: '/dashboard/businessKyc/pnl', tooltip: 'P & L' },
                // { name: 'Balance Sheet', link: '/dashboard/businessKyc/balance-sheet', tooltip: 'Balance Sheet' },
            ],
            isSubmenuVisible: false
        },




        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],

    Self_employed_professional_coApp: [
        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
                { name: 'Aadhar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                // { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                // {
                //   name: 'Credit Report',
                //   link: '/dashboard/businessKyc/crif-report'
                // },
                { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
                { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
                // { name: 'Unit Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'Udyam *', link: '/dashboard/businessKyc/udyam' },
                { name: 'Shops & Establishment', link: '/dashboard/businessKyc/shops' },
                // { name:  'CRIF Commercial', link:'/dashboard/businessKyc/crifCommercial'},

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' },
                { name: 'Other Address Proof', link: '/dashboard/businessKyc/otheraddressproof' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Details',
            faIcon: 'account_balance_wallet',
            submenu: [
                // {name: 'Income Details', link: '/dashboard/businessKyc/income'},
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                { name: 'Payslip/Salary Certificate', link: '/dashboard/businessKyc/payslip' },
                { name: 'Form 16', link: 'form16' },
                // // { name: 'Form 26As', link:'form26as'},
                //  { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - Online FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
                { name: 'Rental Agreement', link: '/dashboard/businessKyc/rental-agreement', tooltip: 'Rental Agreement' },
                // { name: 'P & L', link: '/dashboard/businessKyc/pnl', tooltip: 'P & L' },
                // { name: 'Balance Sheet', link: '/dashboard/businessKyc/balance-sheet', tooltip: 'Balance Sheet' },
            ],
            isSubmenuVisible: false
        },



        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
                // { name: 'Land Verification'},
                // { name: 'Property'}




            ],
            isSubmenuVisible: false
        },



        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],

    superAdminRoles: [
        { id: 1, rolesvalue: "Treasury" },
        { id: 2, rolesvalue: "Secretary" },
        { id: 3, rolesvalue: "CFO" },
        { id: 4, rolesvalue: "Checker" },
        { id: 5, rolesvalue: "Maker" },

    ],

    adminRoles: [
        { id: 2, rolesvalue: "Secretary" },
        { id: 3, rolesvalue: "CFO" },
        { id: 4, rolesvalue: "Checker" },
        { id: 5, rolesvalue: "Maker" },

    ],
    treasuryRoles: [
        { id: 3, rolesvalue: "CFO" },
        { id: 4, rolesvalue: "Checker" },
        { id: 5, rolesvalue: "Maker" },
    ],
    companysecratoryRoles: [
        { id: 4, rolesvalue: "Checker" },
        { id: 5, rolesvalue: "Maker" },
    ],
    approval: [
        { id: 5, rolesvalue: "Maker" },
    ],
    managerRoles: [
        { id: 3, rolesvalue: "TEAM_LEAD" },
        { id: 4, rolesvalue: "EXECUTIVE" },
        { id: 5, rolesvalue: "BANK_SALES" },
        { id: 6, rolesvalue: "BANK_CREDIT" },
        { id: 7, rolesvalue: "BANK_OPERATION" },
        { id: 8, rolesvalue: "BRANCH_USER" },

    ],
    leadRoles: [
        { id: 4, rolesvalue: "EXECUTIVE" },
        { id: 5, rolesvalue: "BANK_SALES" },
        { id: 6, rolesvalue: "BANK_CREDIT" },
        { id: 7, rolesvalue: "BANK_OPERATION" },
        { id: 8, rolesvalue: "BRANCH_USER" },

    ],
    executive: [
        { id: 5, rolesvalue: "BANK_SALES" },
        { id: 6, rolesvalue: "BANK_CREDIT" },
        { id: 7, rolesvalue: "BANK_OPERATION" },
        { id: 8, rolesvalue: "BRANCH_USER" },
    ],
    salesRoles: [
        { id: 6, rolesvalue: "BANK_CREDIT" },
        { id: 7, rolesvalue: "BANK_OPERATION" },
        { id: 8, rolesvalue: "BRANCH_USER" },

    ],

    credit: [
        { id: 7, rolesvalue: "BANK_OPERATION" },
        { id: 8, rolesvalue: "BRANCH_USER" },
    ],
    operationRoles: [

        { id: 8, rolesvalue: "BRANCH_USER" },

    ],


    SUPER_ADMIN: [
        { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },
        { name: 'Set Share Price', icon: 'price_change', link: '/dashboard/setprice-smoke-test' },
        // { name: 'Dashboard', icon: 'dashboard', link: '/dashboard/home' }
        // { name: 'Asset Master', icon: 'inventory_2' , submenu : [
        //   { name: `Car`, link: "/dashboard/viewAsset?type=Car", icon: "directions_car" },
        //   { name: `Bike`, link: "/dashboard/viewAsset?type=Bike", icon: "two_wheeler" },
        //   { name: `Truck`, link: "/dashboard/viewAsset?type=Truck", icon: "local_shipping" },
        //   { name: `Tractor`, link: "/dashboard/viewAsset?type=Tractor", icon: "agriculture" },
        // ]},      
        // { name: 'Interest Master', link: "/dashboard/viewAsset?type=rateOfInterest", icon: 'percent' },
        //  { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
        // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
        // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
        // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
        // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },

    ],


    ADMIN: [
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        // { name: 'Manage Admins', icon: 'business_center',link: '/dashboard/manage-admins'},

    ],


    role2: [

        // { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        // { name: 'Manage Admins', icon: 'business_center',link: '/dashboard/manage-admins'},
        // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
        // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
        // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
        // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
        // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },

    ],

    role3: [

        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        // { name: 'Set Share Price', icon: 'price_change', link: '/dashboard/setprice-smoke-test' },
        // { name: 'Manage Admins', icon: 'business_center',link: '/dashboard/manage-admins'},

    ],

    role4: [

        //  { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },


    ],

    role5: [

        { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        // { name: 'Manage Admins', icon: 'business_center',link: '/dashboard/manage-admins'},
        // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
        // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
        // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
        // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
        // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },

    ],

    role6: [

        { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        // { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        // { name: 'Create Users', link: "/dashboard/create", icon: 'person' },
        // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
        // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
        // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
        // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
        // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },

    ],

    role7: [

        { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        { name: 'Create Users', link: "/dashboard/create", icon: 'person' },
        // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
        // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
        // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
        // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
        // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },

    ],

    role8: [

        { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
        { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
        // { name: 'Create Users', link: "/dashboard/create", icon: 'person' },
        // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
        // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
        // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
        // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
        // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },

    ],

    role356_westend: [

        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar', link: '/dashboard/businessKyc/aadhar' },
                // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                { name: 'Passport', link: '/dashboard/businessKyc/Passport' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' },
                { name: 'Other Address Proof', link: '/dashboard/businessKyc/otheraddressproof' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Details',
            faIcon: 'account_balance_wallet',
            submenu: [
                // {name: 'Income Details', link: '/dashboard/businessKyc/income'},
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                { name: 'Payslips/Salary Certificate', link: '/dashboard/businessKyc/payslip' },
                { name: 'Form 16', link: 'form16' },
                // // { name: 'Form 26As', link:'form26as'},
                //  { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - Online FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
                { name: 'Rental Agreement', link: '/dashboard/businessKyc/rental-agreement', tooltip: 'Rental Agreement' },
                { name: 'P & L', link: '/dashboard/businessKyc/pnl', tooltip: 'P & L' },
                { name: 'Balance Sheet', link: '/dashboard/businessKyc/balance-sheet', tooltip: 'Balance Sheet' },
            ],
            isSubmenuVisible: false
        },


        {
            name: 'Business ID/Proof',
            icon: 'work',
            submenu: [
                // { name: 'Business ID/Proof', link: 'business/commercial' },
                { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
                { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
                { name: 'Udyam', link: '/dashboard/businessKyc/udyam' },
                { name: 'Shops & Estd', link: '/dashboard/businessKyc/shops' },
                { name: 'FSSAI', link: '/dashboard/businessKyc/fssai' },
                { name: 'IEC', link: '/dashboard/businessKyc/iec' },
                { name: 'FDA', link: '/dashboard/businessKyc/fda' },

            ],
            isSubmenuVisible: false
        },


        {
            name: 'Professional ID',
            faIcon: 'folder_shared',
            submenu: [
                { name: 'ICAI', link: '/dashboard/businessKyc/icai' },
                { name: 'ICSI', link: '/dashboard/businessKyc/icsi' },
                { name: 'ICWAI Firm', link: '/dashboard/businessKyc/icwaif' },
                { name: 'ICWAI Membership', link: '/dashboard/businessKyc/icwaim' },
                { name: 'MCI Membership', link: '/dashboard/businessKyc/mci' },


            ],
            isSubmenuVisible: false
        },


        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Bureau Check',
            icon: 'credit_card',
            submenu: [
                { name: 'Customer Consent Form', link: '/dashboard/businessKyc/crif-report' },

            ]
        },


        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],


    role78_westend: [

        {
            name: 'Dashboard',
            icon: 'dashboard',
            link: '/dashboard/businessKyc/dashboard'
        },


        {
            name: 'Fetch Documents From Digilocker',
            icon: 'cloud_download',
            link: '/dashboard/businessKyc/digilocker'
        },

        {
            name: 'KYC',
            icon: 'fingerprint',
            submenu: [
                { name: 'Aadhaar', link: '/dashboard/businessKyc/aadhar' },
                // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
                { name: 'PAN', link: '/dashboard/businessKyc/pan' },
                { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
                { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
                { name: 'Passport', link: '/dashboard/businessKyc/Passport' },
            ],
            isSubmenuVisible: false
        },

        {
            name: 'Address Proof',
            icon: 'contacts',
            submenu: [

                { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
                { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
                { name: 'LPG', link: '/dashboard/businessKyc/lpg' },
                { name: 'Other Address Proof', link: '/dashboard/businessKyc/otheraddressproof' }

            ],
            isSubmenuVisible: false
        },

        {
            name: 'Income Details',
            faIcon: 'account_balance_wallet',
            submenu: [
                // {name: 'Income Details', link: '/dashboard/businessKyc/income'},
                { name: 'EPF', link: '/dashboard/businessKyc/epf' },
                { name: 'Payslips/Salary Certificate', link: '/dashboard/businessKyc/payslip' },
                { name: 'Form 16', link: 'form16' },
                // // { name: 'Form 26As', link:'form26as'},
                //  { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
                { name: 'ITR - Online FETCH *', link: '/dashboard/businessKyc/itrfetch' },
                { name: 'Bank Account *', link: 'bankAcc' },
                { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
                { name: 'Rental Agreement', link: '/dashboard/businessKyc/rental-agreement', tooltip: 'Rental Agreement' },
                { name: 'P & L', link: '/dashboard/businessKyc/pnl', tooltip: 'P & L' },
                { name: 'Balance Sheet', link: '/dashboard/businessKyc/balance-sheet', tooltip: 'Balance Sheet' },
            ],
            isSubmenuVisible: false
        },


        {
            name: 'Business ID/Proof',
            icon: 'work',
            submenu: [
                // { name: 'Business ID/Proof', link: 'business/commercial' },
                { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
                { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
                { name: 'Udyam', link: '/dashboard/businessKyc/udyam' },
                { name: 'Shops & Estd', link: '/dashboard/businessKyc/shops' },
                { name: 'FSSAI', link: '/dashboard/businessKyc/fssai' },
                { name: 'IEC', link: '/dashboard/businessKyc/iec' },
                { name: 'FDA', link: '/dashboard/businessKyc/fda' },

            ],
            isSubmenuVisible: false
        },


        {
            name: 'Professional ID',
            faIcon: 'folder_shared',
            submenu: [
                { name: 'ICAI', link: '/dashboard/businessKyc/icai' },
                { name: 'ICSI', link: '/dashboard/businessKyc/icsi' },
                { name: 'ICWAI Firm', link: '/dashboard/businessKyc/icwaif' },
                { name: 'ICWAI Membership', link: '/dashboard/businessKyc/icwaim' },
                { name: 'MCI Membership', link: '/dashboard/businessKyc/mci' },


            ],
            isSubmenuVisible: false
        },


        {
            name: 'Asset Verification',
            faIcon: 'assignment_turned_in',
            submenu: [

                { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
            ],
            isSubmenuVisible: false
        },

        //      {
        //   name: 'Bureau Check',
        //   icon: 'credit_card',
        //   submenu: [
        //     { name: 'Customer Consent Form', link: '/dashboard/businessKyc/crif-report' },

        //   ]
        // },


        {
            name: 'Validation Report',
            icon: 'fact_check',
            link: '/dashboard/businessKyc/valReport'
        },
        {
            name: 'DPR',
            faIcon: 'assignment_turned_in',
            link: '/dashboard/businessKyc/dpr'
        },

    ],

    role0135_homeLoan: [
        {
            name: 'Add Co-Applicant',
            icon: 'supervisor_account',
            link: '/dashboard/loan/view-coapplicants'
        },
        {
            name: 'Add Guarantor',
            icon: 'supervisor_account',
            link: '/dashboard/loan/view-guarantors'
        },

        {
            name: 'Personal Details',
            icon: 'contact_page',
            link: '/dashboard/loan/personal'
        },
        {
            name: 'Property Details',
            icon: 'business_center',
            link: '/dashboard/loan/propertyDetails'
        },
        {
            name: 'Income Details',
            icon: 'payments',
            link: '/dashboard/loan/income'
        },

        {
            name: 'Risk Profiling',
            icon: 'analytics',
            link: '/dashboard/loan/riskProfilling'
        },
        {
            name: 'Processing Fee',
            icon: 'payments',
            link: '/dashboard/loan/processingFee'
        },

        {
            name: 'PD + CVR',
            icon: 'domain_verification',
            link: '/dashboard/loan/pd+cvr'
        },
        {
            name: 'Loan Application',
            icon: 'feed',
            // link: 'laas/applications/apply'
        },


        {
            name: 'Upload Application',
            icon: 'upload_file',
            link: '/dashboard/loan/uploadApplication'
        },

        {
            name: 'File Movement',
            icon: 'file_open',
            // link: 'laas/loans/apply',
            link: '/dashboard/loan/fileMovement'
        },

    ],

    role2_homeLoan: [
        {
            name: 'Approval',
            icon: 'description',
            // link: 'laas/loans/apply',
            link: '/dashboard/loan/approval'
        },


        {
            name: 'Processing Fee',
            icon: 'payments',
            link: '/dashboard/loan/processingFee'
        },
        {
            name: 'Loan Application',
            icon: 'feed',
            // link: 'laas/applications/apply'
        },


        {
            name: 'Upload Application',
            icon: 'upload_file',
            link: '/dashboard/loan/uploadApplication'
        },

        {
            name: 'File Movement',
            icon: 'file_open',
            // link: 'laas/loans/apply',
            link: '/dashboard/loan/fileMovement'
        },
    ],

    role4_homeLoan: [

        {
            name: 'Property Details',
            icon: 'business_center',
            link: '/dashboard/loan/propertyDetails'
        },

        {
            name: 'Processing Fee',
            icon: 'payments',
            link: '/dashboard/loan/processingFee'
        },


        {
            name: 'File Movement',
            icon: 'file_open',
            // link: 'laas/loans/apply',
            link: '/dashboard/loan/fileMovement'
        },
    ],
    role6_homeLoan: [
        {
            name: 'Add Co-Applicant',
            icon: 'supervisor_account',
            link: '/dashboard/loan/view-coapplicants'
        },
        {
            name: 'Add Guarantor',
            icon: 'supervisor_account',
            link: '/dashboard/loan/view-guarantors'
        },

        {
            name: 'Personal Details',
            icon: 'contact_page',
            link: '/dashboard/loan/personal'
        },
        {
            name: 'Property Details',
            icon: 'business_center',
            link: '/dashboard/loan/propertyDetails'
        },
        {
            name: 'Income Details',
            icon: 'payments',
            link: '/dashboard/loan/income'
        },

        //  {
        //   name: 'Risk Profiling',
        //   icon: 'analytics',
        //   link: '/dashboard/loan/riskProfilling'
        // },
        {
            name: 'Processing Fee',
            icon: 'payments',
            link: '/dashboard/loan/processingFee'
        },

        {
            name: 'PD + CVR',
            icon: 'domain_verification',
            link: '/dashboard/loan/pd+cvr'
        },
        {
            name: 'Loan Application',
            icon: 'feed',
            // link: 'laas/applications/apply'
        },


        {
            name: 'Upload Application',
            icon: 'upload_file',
            link: '/dashboard/loan/uploadApplication'
        },

        {
            name: 'File Movement',
            icon: 'file_open',
            // link: 'laas/loans/apply',
            link: '/dashboard/loan/fileMovement'
        },

    ],
    role78_homeLoan: [
        {
            name: 'Add Co-Applicant',
            icon: 'supervisor_account',
            link: '/dashboard/loan/view-coapplicants'
        },
        {
            name: 'Add Guarantor',
            icon: 'supervisor_account',
            link: '/dashboard/loan/view-guarantors'
        },

        {
            name: 'Personal Details',
            icon: 'contact_page',
            link: '/dashboard/loan/personal'
        },
        {
            name: 'Property Details',
            icon: 'business_center',
            link: '/dashboard/loan/propertyDetails'
        },
        {
            name: 'Income Details',
            icon: 'payments',
            link: '/dashboard/loan/income'
        },

        //  {
        //   name: 'Risk Profiling',
        //   icon: 'analytics',
        //   link: '/dashboard/loan/riskProfilling'
        // },
        {
            name: 'Processing Fee',
            icon: 'payments',
            link: '/dashboard/loan/processingFee'
        },

        // {
        //   name: 'PD + CVR',
        //   icon: 'domain_verification',
        //   link: '/dashboard/loan/pd+cvr'
        // },
        {
            name: 'Loan Application',
            icon: 'feed',
            // link: 'laas/applications/apply'
        },


        {
            name: 'Upload Application',
            icon: 'upload_file',
            link: '/dashboard/loan/uploadApplication'
        },

        {
            name: 'File Movement',
            icon: 'file_open',
            // link: 'laas/loans/apply',
            link: '/dashboard/loan/fileMovement'
        },

    ],

};
